
import GiftshopService from '@/services/GiftshopService';
import { CbxVariablesModule } from '@/store/modules/CbxVariablesModule';
import { Component, Prop, Vue } from 'vue-property-decorator';

const service: GiftshopService = new GiftshopService();

@Component({
    name: 'GiftshopLoginButton',
    components: {
    }
})
export default class GiftshopLoginButton extends Vue {
    @Prop({ type: String, required: true }) loginText: string;
    @Prop({ type: String, required: true }) signoutText: string;

    get isSignedIn(): boolean {
        return CbxVariablesModule.VARIABLES.signinstatus;
    }

    async handleClick() {
        if (this.isSignedIn) {
            if (await service.signOut())
                location.reload();
        }
        else {
            location.href = "https://www.gavevalget.com";
        }
    }
}
